import { IconCompass } from "@suse-o11y/icons";
import React from "react";

import { useNavigateToLink } from "../../components/react/link";
import { SESSIONS_PATH } from "../../routes/Routes";

import { MainMenuItemLayout } from "./MainMenuItemLayout";

export const MainMenuItemSessions: React.FC = () => {
	const link = useNavigateToLink(SESSIONS_PATH, {
		search: [],
	});

	return <MainMenuItemLayout icon={<IconCompass height={18} width={18} />} label="AI Sessions" to={link} />;
};
